<template>
  <div
    :class="['plan-section', 'card', cardType === 'includes' ? 'includes-card' : 'excludes-card']"
    data-aos="fade-up"
    :data-aos-delay="delay"
  >
    <div :class="['card-bg-shape', { red: cardType === 'excludes' }]"></div>

    <div class="floating-shapes">
      <div :class="['triangle', cardType === 'includes' ? 't1' : 't2']"></div>
      <div :class="['circle', cardType === 'includes' ? 'c1' : 'c2']"></div>
    </div>

    <div class="card-content">
      <div class="card-header">
        <div class="header-flow-content">
          <div
            v-if="isAccordionMode && expandedServiceIndex !== null"
            @click="resetExpansion"
            class="back-button"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            <span>Back</span>
          </div>
          <div v-else class="title-icon-group">
            <div
              :class="['header-icon', cardType === 'includes' ? 'includes-icon' : 'addons-icon']"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  :fill="cardType === 'includes' ? '#10B981' : '#05D9FF'"
                />
                <path
                  v-if="cardType === 'includes'"
                  d="m9 12 2 2 4-4"
                  stroke="#fff"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  v-else
                  d="M12 8v8M8 12h8"
                  stroke="#fff"
                  stroke-width="2.5"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <h3>{{ title }}</h3>
          </div>
        </div>
        <h3 v-if="isAccordionMode && expandedServiceIndex !== null" class="expanded-title">
          {{ expandedServiceTitle }}
        </h3>
      </div>
      <template v-if="isAccordionMode">
        <ul class="enhanced-list" v-if="expandedServiceIndex === null">
          <li
            v-for="(service, index) in features"
            :key="index"
            class="service-group-button"
            @click="expandService(index)"
          >
            <div class="service-title-content">
              <div
                :class="['bullet-icon', cardType === 'includes' ? 'includes-icon' : 'addons-icon']"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    :fill="cardType === 'includes' ? '#10B981' : '#05D9FF'"
                  />
                  <path
                    v-if="cardType === 'includes'"
                    d="m9 12 2 2 4-4"
                    stroke="#fff"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    v-else
                    d="M12 8v8M8 12h8"
                    stroke="#fff"
                    stroke-width="2.5"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <span class="service-name-text">
                {{
                  service?.includes_services || service?.excludes_services || service?.service_name
                }}
              </span>
            </div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#64748b"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="expand-arrow"
            >
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </li>
        </ul>
        <div v-if="expandedServiceIndex !== null" class="expanded-description">
          <ul class="service-description-list">
            <li
              v-for="(desc, i) in features[expandedServiceIndex].service_description"
              :key="i"
              class="fade-in-item enhanced-item"
              :style="{ animationDelay: `${i * 0.05}s` }"
            >
              <div
                :class="['bullet-icon', cardType === 'includes' ? 'includes-icon' : 'addons-icon']"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    :fill="cardType === 'includes' ? '#10B981' : '#05D9FF'"
                  />
                  <path
                    v-if="cardType === 'includes'"
                    d="m9 12 2 2 4-4"
                    stroke="#fff"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    v-else
                    d="M12 8v8M8 12h8"
                    stroke="#fff"
                    stroke-width="2.5"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <span class="item-text">{{ desc }}</span>
            </li>
          </ul>
        </div>
      </template>
      <ul v-else class="enhanced-list">
        <li
          v-for="(item, index) in features"
          :key="index"
          class="fade-in-item enhanced-item simple-list-item"
          :style="{ animationDelay: `${index * 0.1}s` }"
        >
          <div
            :class="[
              'bullet-icon',
              cardType === 'includes' ? 'includes-bullet-small' : 'excludes-bullet-small',
            ]"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="8" :fill="cardType === 'includes' ? '#10B981' : '#EF4444'" />
              <path
                v-if="cardType === 'includes'"
                d="m5 8 2 2 4-4"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                v-else
                d="m11 5-6 6m0-6 6 6"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <span class="item-text">{{ item }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanFeatureCard',
  props: {
    title: String,
    features: Array,
    cardType: String,
    delay: String,
  },
  data() {
    return { expandedServiceIndex: null };
  },
  computed: {
    isAccordionMode() {
      return this.features?.length && typeof this.features[0] === 'object';
    },
    expandedServiceTitle() {
      const s = this.features[this.expandedServiceIndex];
      return s?.includes_services || s?.excludes_services || this.title;
    },
  },
  methods: {
    expandService(i) {
      this.expandedServiceIndex = i;
    },
    resetExpansion() {
      this.expandedServiceIndex = null;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700;900&display=swap');

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding: 0 0 20px 0;
  border-bottom: 2px solid rgba(0, 0, 0, 0.05);
  transition:
    border-color 0.3s ease,
    padding 0.3s ease,
    box-shadow 0.3s ease;
  position: relative;
}

.header-flow-content {
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.title-icon-group {
  display: flex;
  align-items: center;
  transition: opacity 0.3s ease;
}

.expanded-title {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: #1e293b;
  margin-left: auto;
  text-align: right;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 14px;
  margin-left: -4px;
  cursor: pointer;
  color: #f46523;
  background-color: #fff;
  border: 1px solid rgba(244, 101, 35, 0.2);
  border-radius: 50px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.2px;
  box-shadow: 0 1px 3px rgba(244, 101, 35, 0.1);
  flex-shrink: 0;
}

.back-button:hover {
  color: #fff;
  background-color: #f46523;
  border-color: #f46523;
  box-shadow:
    0 4px 10px rgba(244, 101, 35, 0.4),
    0 0 0 3px rgba(244, 101, 35, 0.1);
  transform: translateY(-1px);
}

.back-button svg {
  stroke: currentColor;
  transition: stroke 0.3s ease;
}

.back-button:hover svg {
  stroke: #fff;
}

.header-icon {
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: rubberBand 1.5s infinite alternate;
}

.includes-icon svg circle {
  filter: drop-shadow(0 2px 8px rgba(16, 185, 129, 0.3));
}

.excludes-icon svg circle {
  filter: drop-shadow(0 2px 8px rgba(239, 68, 68, 0.3));
}

.service-group-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  cursor: pointer;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.service-group-button:hover {
  background-color: #fefefe;
  transform: translateY(-2px) scale(1.01);
  box-shadow: 0 6px 15px rgba(244, 101, 35, 0.15);
  padding: 10px 15px;
}

.service-group-button:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(244, 101, 35, 0.05), transparent);
  opacity: 0;
  transform: translateX(-100%);
  transition: all 0.8s cubic-bezier(0.25, 0.8, 0.25, 1);
  z-index: -1;
  border-radius: inherit;
}

.service-group-button:hover:before {
  opacity: 1;
  transform: translateX(0);
}

.service-title-content {
  display: flex;
  align-items: center;
  flex-grow: 1;
  z-index: 2;
}

.service-name-text {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  transition:
    color 0.3s ease,
    transform 0.3s ease;
}

.service-group-button:hover .service-name-text {
  color: #f46523;
  transform: translateX(2px);
}

.expand-arrow {
  margin-left: 10px;
  transition:
    transform 0.3s ease,
    stroke 0.3s ease;
  flex-shrink: 0;
}

.service-group-button:hover .expand-arrow {
  transform: translateX(8px) scale(1.2);
  stroke: #f46523;
}

.service-group-button .bullet-icon {
  transform: scale(0.85);
  margin-right: 12px;
  flex-shrink: 0;
  transition: transform 0.4s ease;
}

.service-group-button:hover .bullet-icon {
  transform: scale(1.05) rotate(5deg);
}

.service-group-button .includes-bullet svg {
  filter: drop-shadow(0 2px 6px rgba(16, 185, 129, 0.2));
  width: 20px;
  height: 20px;
}
.service-group-button .excludes-bullet svg {
  filter: drop-shadow(0 2px 6px rgba(239, 68, 68, 0.2));
  width: 20px;
  height: 20px;
}

.enhanced-list {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.enhanced-item {
  display: flex;
  align-items: flex-start;
  margin: 6px 0;
  padding: 6px 12px;
  transition:
    all 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.5s ease,
    background 0.5s ease,
    border-radius 0.4s ease,
    backdrop-filter 0.4s ease,
    opacity 0.3s ease;
  position: relative;
  border-radius: 8px;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  will-change: transform, background, box-shadow;
}

.enhanced-item:hover {
  transform: translateX(6px) scale(1.02) translateZ(0) rotateY(1deg);
  background:
    linear-gradient(90deg, rgba(244, 101, 35, 0.04), rgba(244, 101, 35, 0.02), transparent),
    radial-gradient(circle at 0% 50%, rgba(244, 101, 35, 0.02), transparent 50%);
  border-radius: 16px;
  padding: 10px 20px;
  margin: 4px -20px;
  box-shadow:
    0 4px 20px rgba(244, 101, 35, 0.08),
    0 8px 40px rgba(244, 101, 35, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.1),
    inset 0 0 20px rgba(244, 101, 35, 0.02);
  backdrop-filter: blur(10px);
}

.enhanced-item:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent, rgba(244, 101, 35, 0.05), transparent);
  opacity: 0;
  transition:
    opacity 0.4s ease,
    transform 0.4s ease;
  border-radius: inherit;
  pointer-events: none;
}

.enhanced-item:hover:before {
  opacity: 1;
  transform: translateX(100%);
}

.bullet-icon {
  margin-right: 16px;
  margin-top: 2px;
}

.enhanced-item:hover .bullet-icon {
  transform: scale(1.2) rotate(360deg) translateZ(0) rotateY(15deg);
}

.includes-bullet-small svg,
.excludes-bullet-small svg {
  width: 16px;
  height: 16px;
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.1));
}

.item-text {
  font-size: 16px;
  color: #374151;
  line-height: 1.6;
  font-weight: 500;
  animation: slideInFade 0.8s ease-out both;
  position: relative;
  transition:
    color 0.4s ease,
    font-weight 0.4s ease,
    transform 0.4s ease,
    text-shadow 0.4s ease,
    letter-spacing 0.3s ease,
    opacity 0.3s ease;
  will-change: transform, color;
}
.addons-icon svg circle {
  filter: drop-shadow(0 2px 8px rgba(5, 217, 255, 0.4));
}

.enhanced-item:hover .item-text {
  color: #1f2937;
  font-weight: 600;
  transform: translateY(-1px) translateZ(0) scale(1.01);
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.2px;
}

.item-text::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #f46523, #ff9800, #ffd700);
  transition:
    width 0.6s cubic-bezier(0.4, 0, 0.2, 1),
    height 0.3s ease,
    box-shadow 0.4s ease;
  box-shadow: 0 1px 3px rgba(244, 101, 35, 0.3);
  border-radius: 1px;
}

.enhanced-item:hover .item-text::after {
  width: 100%;
  height: 3px;
  box-shadow: 0 2px 6px rgba(244, 101, 35, 0.5);
}

.simple-list-item {
  padding: 6px 12px;
  margin: 6px 0;
  cursor: default;
}
.simple-list-item:hover {
  transform: none;
  background: none;
  border-radius: 8px;
  padding: 6px 12px;
  margin: 6px 0;
  box-shadow: none;
  backdrop-filter: none;
}
.simple-list-item:hover .bullet-icon {
  transform: none;
}
.simple-list-item .item-text {
  font-weight: 500;
  text-shadow: none;
  letter-spacing: normal;
}
.simple-list-item:hover .item-text {
  font-weight: 500;
  color: #374151;
  transform: none;
  text-shadow: none;
  letter-spacing: normal;
}
.simple-list-item .item-text::after {
  width: 0 !important;
  height: 0 !important;
  box-shadow: none !important;
}
.simple-list-item .bullet-icon {
  margin-right: 12px;
}

.card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  padding: 32px 28px;
  border-radius: 20px;
  box-shadow:
    0 4px 20px rgba(0, 0, 0, 0.08),
    0 8px 40px rgba(0, 0, 0, 0.05),
    0 16px 80px rgba(0, 0, 0, 0.02);
  transition:
    transform 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    box-shadow 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    border-color 0.5s ease,
    background 0.5s ease,
    filter 0.4s ease,
    backdrop-filter 0.4s ease;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.8);
  will-change: transform, box-shadow;
}

.card:hover {
  transform: translateY(-12px) scale(1.03) rotateX(2deg);
  box-shadow:
    0 8px 30px rgba(0, 0, 0, 0.12),
    0 16px 60px rgba(0, 0, 0, 0.08),
    0 32px 120px rgba(0, 0, 0, 0.04),
    0 0 0 1px rgba(244, 101, 35, 0.1);
  border-color: rgba(244, 101, 35, 0.2);
  background: linear-gradient(135deg, #ffffff 0%, #fefefe 100%);
  filter: brightness(1.02) saturate(1.05);
}

.card-bg-shape {
  position: absolute;
  top: 0;
  right: 0;
  width: 140px;
  height: 140px;
  background: linear-gradient(135deg, #f46523, #ff9800);
  clip-path: polygon(40% 0%, 100% 0, 100% 60%);
  opacity: 0.08;
  transition:
    opacity 0.4s ease,
    transform 0.4s ease,
    filter 0.3s ease;
}

.card-bg-shape.red {
  background: linear-gradient(135deg, #ef4444, #dc2626);
}

.card:hover .card-bg-shape {
  opacity: 0.15;
  transform: scale(1.1) rotate(5deg);
  filter: blur(0.5px);
}

.card h3 {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: #1e293b;
}

.floating-shapes .triangle,
.floating-shapes .circle {
  position: absolute;
  opacity: 0.1;
}

.t1 {
  top: 20px;
  right: 40px;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 35px solid #f46523;
  animation: float 4s infinite ease-in-out;
}

.t2 {
  bottom: 20px;
  left: 30px;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 35px solid #ef4444;
  animation: float 5s infinite ease-in-out;
}

.c1,
.c2 {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  animation: float 6s infinite ease-in-out reverse;
}

.c1 {
  top: 50px;
  left: 50px;
  background: #f46523;
}

.c2 {
  bottom: 40px;
  right: 40px;
  background: #ef4444;
}

@media (max-width: 768px) {
  .card {
    padding: 24px 20px;
  }
  .enhanced-item:hover {
    transform: translateX(4px) scale(1.01) translateZ(0);
    box-shadow:
      0 2px 12px rgba(244, 101, 35, 0.06),
      0 4px 24px rgba(244, 101, 35, 0.03);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}

@keyframes slideInFade {
  0% {
    opacity: 0;
    transform: translateX(20px) translateY(10px);
  }
  50% {
    opacity: 0.7;
    transform: translateX(-2px) translateY(-2px);
  }
  100% {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}

@keyframes rubberBand {
  0% {
    transform: scale3d(1, 1, 1);
  }
  30% {
    transform: scale3d(1.15, 0.85, 1);
  }
  40% {
    transform: scale3d(0.85, 1.15, 1);
  }
  50% {
    transform: scale3d(1.05, 0.95, 1);
  }
  65% {
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    transform: scale3d(1.02, 0.98, 1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}

@keyframes glowPulse {
  0% {
    filter: drop-shadow(0 2px 6px rgba(16, 185, 129, 0.2));
  }
  100% {
    filter: drop-shadow(0 4px 12px rgba(16, 185, 129, 0.4));
  }
}
</style>
